import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setCart } from "../Redux/CartSlice";
import {
  getCartByUserId,
  updateCartOnServer,
  deleteCartOnServer,
} from "../services/Cart/CartPage";

export const usePackageCartActions = () => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.items || []);

  // ================= USER =================
  const getUserId = () =>
    JSON.parse(localStorage.getItem("medarphaUser") || "{}")?.userId;

  // ================= REFRESH =================
  const refreshCart = async () => {
    const userId = getUserId();
    if (!userId) return;

    const res = await getCartByUserId(userId);

    dispatch(setCart(res?.items || []));

    if (res?.cartId) {
      localStorage.setItem("cartId", res.cartId);
    }
  };

  // ================= STORE CHECK =================
  const hasDifferentStore = (storeId) => {
    const existingStoreIds = cart
      .map((i) => Number(i.storeId))
      .filter(Boolean);

    return (
      existingStoreIds.length > 0 &&
      !existingStoreIds.includes(Number(storeId))
    );
  };

  // ================= CLEAR CART =================
  const clearCart = async () => {
    const cartId = localStorage.getItem("cartId");

    if (cartId && cartId !== "0") {
      try {
        await deleteCartOnServer(cartId);
        toast.success("Cart cleared");
      } catch (err) {
        console.error("DELETE ERROR:", err);
        toast.error("Failed to clear cart");
      }
    } else {
      toast.info("Cart already empty");
    }

    dispatch(setCart([]));
    localStorage.removeItem("cartId");
  };

  // ================= ADD PACKAGE =================
  const addPackage = async (pkg) => {
    try {
      const userId = getUserId();
      if (!userId) return;

      const productId = pkg?.packageId;
      const storeId = pkg?.labId;

      if (!productId) {
        console.error("❌ packageId missing:", pkg);
        toast.error("Invalid package");
        return;
      }

      if (hasDifferentStore(storeId)) {
        const ok = window.confirm("Different lab detected. Replace cart?");
        if (!ok) return;

        toast.info("Replacing cart...");
        await clearCart();
        await new Promise((r) => setTimeout(r, 300));
      }

      const originalPrice = Number(pkg.packagePrice || 0);
      const price = Number(pkg.discountPrice || pkg.packagePrice || 0);

      const payload = {
        userId,
        productId,
        categoryId: 3,
        totalQuantity: 1,
        price,
        discount: originalPrice - price,
        originalPrice,
        coupon: "",
        storeId,
        ItemName: pkg.packageName || "",
      };

      console.log("📤 ADD PACKAGE PAYLOAD:", payload);

      await updateCartOnServer(payload);
      await refreshCart();

      toast.success(`${pkg.packageName || "Package"} added to cart`);
    } catch (err) {
      console.error("ADD PACKAGE ERROR:", err);
      toast.error("Failed to add package");
    }
  };

  // ================= REMOVE PACKAGE =================
  const removePackage = async (pkg) => {
    try {
      const userId = getUserId();

      if (!userId) {
        toast.warn("Please login first");
        return;
      }

      const productId = pkg?.packageId;

      if (!productId) {
        console.error("❌ REMOVE: packageId missing", pkg);
        toast.error("Invalid package");
        return;
      }

      const payload = {
        userId,
        productId,
        categoryId: 3,
        totalQuantity: -1,
        price: pkg?.packagePrice || pkg?.price || 0,
        discount: 0,
        coupon: "",
      };

      console.log("🟡 REMOVE PAYLOAD:", payload);

      await updateCartOnServer(payload);
      await refreshCart();

      // ✅ FIXED TOAST (remove bug corrected)
      toast.info(`${pkg.packageName || "Package"} removed from cart`);

    } catch (err) {
      console.error("REMOVE PACKAGE ERROR:", err);
      toast.error("Failed to remove package");
    }
  };

  return {
    addPackage,
    removePackage,
    refreshCart,
    clearCart,
    hasDifferentStore,
  };
};